/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TemplateRecommendedReleasesReleases
 */
export interface TemplateRecommendedReleasesReleases {
    /**
     * タイトル
     * @type {string}
     * @memberof TemplateRecommendedReleasesReleases
     */
    title: string;
    /**
     * サムネイル画像のURL
     * @type {string}
     * @memberof TemplateRecommendedReleasesReleases
     */
    thumbnailUrl: string;
    /**
     * プレスリリースのURL
     * @type {string}
     * @memberof TemplateRecommendedReleasesReleases
     */
    releaseUrl: string;
}

export function TemplateRecommendedReleasesReleasesFromJSON(json: any): TemplateRecommendedReleasesReleases {
    return TemplateRecommendedReleasesReleasesFromJSONTyped(json, false);
}

export function TemplateRecommendedReleasesReleasesFromJSONTyped(json: any, ignoreDiscriminator: boolean): TemplateRecommendedReleasesReleases {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': json['title'],
        'thumbnailUrl': json['thumbnail_url'],
        'releaseUrl': json['release_url'],
    };
}

export function TemplateRecommendedReleasesReleasesToJSON(value?: TemplateRecommendedReleasesReleases | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'thumbnail_url': value.thumbnailUrl,
        'release_url': value.releaseUrl,
    };
}

